import { LegalDocumentLinks } from "@/features/legal/components/LegalDocumentLinks";
import { LEGAL_COMPLIANCE_COPY } from "@/features/legal/config/legal.config";
import type { LegalDocument } from "@/features/legal/types/legalCompliance.type";

type LegalCompliancePrivacyNoteProps = {
  documents: LegalDocument[]
  onOpen: (document: LegalDocument) => void
};

// Notices frozen with the publication: information only, never accepted.
export const LegalCompliancePrivacyNote = ({ documents, onOpen }: LegalCompliancePrivacyNoteProps) => {
  if (documents.length === 0) return null;

  return (
    <nav aria-label={LEGAL_COMPLIANCE_COPY.PRIVACY_LINKS_LABEL} className="border-t border-gray-200 pt-5 dark:border-gray-700">
      <LegalDocumentLinks
        documents={documents}
        onOpen={onOpen}
        linkClassName="text-xs text-gray-500 no-underline hover:text-primary hover:underline dark:text-gray-400"
      />
    </nav>
  );
};

LegalCompliancePrivacyNote.displayName = "LegalCompliancePrivacyNote";
